import { isUndefined } from 'lodash';
import { useState } from 'react';
import { useDebounce, usePreviousDistinct } from 'react-use';

import { AppointmentWithinScheduleQuery } from '@dreryk/egabinet-appointment-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { Range } from '@dreryk/watermelon';
import { useCqrsGet } from '@dreryk/command-query-react-common';

const DELAY_IN_MS = 1000;

type UseAppointmentWithinScheduleOptions = {
   startTime: Date;
   endTime: Date;
   practitionerId: PractitionerId;
};

export const useAppointmentWithinSchedule = (options: UseAppointmentWithinScheduleOptions): boolean | undefined => {
   const [cachedOptions, setCachedOptions] = useState(options);

   useDebounce(
      () => {
         setCachedOptions({
            startTime: cachedOptions.startTime,
            endTime: cachedOptions.endTime,
            practitionerId: cachedOptions.practitionerId,
         });
      },
      DELAY_IN_MS,
      [options.startTime.toString(), options.endTime.toString(), options.practitionerId]
   );

   const { data: appointmentWithinSchedule } = useCqrsGet<boolean>(() => {
      const query = new AppointmentWithinScheduleQuery();
      query.appointmentDateRange = Range.closedOpen(cachedOptions.startTime, cachedOptions.endTime);
      query.practitionerId = cachedOptions.practitionerId;
      return query;
   });

   const lastAppointmentWithinSchedule = usePreviousDistinct(appointmentWithinSchedule, (__, next) =>
      isUndefined(next)
   );

   return appointmentWithinSchedule ?? lastAppointmentWithinSchedule;
};
